import './styles.scss'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from 'primereact/card'
import LayoutContainer from 'Components/LayoutComponent'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { ROUTE_STRINGS } from 'Utils/Constants'
import { getLocalUserDetails } from 'Utils/LocalStorageHandler'

const Dashboard = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const userDetails = getLocalUserDetails()

  useEffect(() => {
    if (userDetails?.isDashboardAvailable) {
      history.push(ROUTE_STRINGS.adminDashboard)
    }
  }, [])

  return (
    <LayoutContainer breadCrumbsTitle={'dashBoard'}>
      <Card className="dashboard-container">
        <h1 className="">{t('welcomeToCW')}</h1>
      </Card>
    </LayoutContainer>
  )
}

export default Dashboard
